// extracted by mini-css-extract-plugin
export default {"bannerImageYouAreInLabelWrapper":"BannerImage_bannerImageYouAreInLabelWrapper--nDF","image":"BannerImage_image--uaO"};